import * as yup from 'yup'

const getProductSchema = (product_type: string) => {
    switch (product_type) {
        case 'Content Delivery Network':
        case 'Transcoding':
        case 'Recording':
        case 'Storage':
        case 'Transmuxing':
            return CDNServiceValidator

        case 'Hosting':
        case 'Cloud Server':
        case 'VNIS':
        case 'Bare Metal Server':
            return HostingServiceValidator
        default:
            return yup.object().shape({
                product_group_name: yup.string().required(),
                product_id: yup.number().min(1).required(),
            })
    }
}

const servicePocSchema = yup.object().shape({
    service_start_date: yup.date().required(),
    service_stopped_date: yup
        .date()
        .required()
        .test({
            name: 'stopped_after_start',
            message: 'enddate-must-be-gte-startdate',
            test: function (value) {
                const { service_start_date } = this.parent
                if (!value || !service_start_date) return true // để tránh lỗi khi 1 trong 2 chưa nhập
                return value >= service_start_date
            },
        }),
    customer_id: yup.number().min(1).required(),
    // customer_journey_id: yup.number().min(1).required(),
    products: yup
        .array()
        .of(
            yup.lazy((product) => {
                return getProductSchema(product.product_group_name)
            })
        )
        .min(1),
    // The form keeps products under `order.products` (the `products` rules above
    // never match a form key). Only the POC pricing rule is validated here.
    order: yup.object().shape({
        products: yup.array().of(
            yup.object().shape({
                is_paid: yup.boolean(),
                poc_price: yup
                    .number()
                    .nullable()
                    .when('is_paid', {
                        is: true,
                        then: (schema) =>
                            schema
                                .required('customer:poc_price_required')
                                .moreThan(0, 'customer:poc_price_required'),
                    }),
            })
        ),
    }),
})

const baseValidator = {
    product_id: yup.number().min(1).required(),
    product_group_name: yup.string().required(),
}

const CDNServiceValidator = yup.object().shape({
    ...baseValidator,
    product_form: yup.string().required(),
})

const HostingServiceValidator = yup.object().shape({
    ...baseValidator,
    service_configoptions: yup.array().of(
        yup.object().shape({
            commitment_value: yup.number().min(1).optional(),
            unit: yup.string().required(),
        })
    ),
})

export default servicePocSchema
